import { User } from 'firebase/auth';
import { doc, setDoc } from 'firebase/firestore';
import { firestore } from '~/firebase/init';

export default async function initCustomer(platformId: string, auth: User) {
  const customerRef = doc(firestore, 'platforms', platformId, 'customers', auth.uid);

  await setDoc(
    customerRef,
    {
      displayName: auth.displayName,
      phoneNumber: auth.phoneNumber,
      containers: {},
      recentAddresses: [],
    },
    { merge: true },
  );
}
